/// <amd-module name="Dashboards/Directory/components/FavoriteNameCell" />
import * as FavoritesTelemetry from "Favorites/Common/Telemetry";
import { FavoritesStarButton } from "Favorites/Star/FavoritesStarButton";
import * as React from "react";
import { connect } from "react-redux";
import { DirectoryGroupKeys } from "VSS/Features/Directory/DirectoryConstants";
import { IDirectoryArtifact, IFavoriteData } from "VSS/Features/Directory/DirectoryContracts";
import { IDirectoryRow, NameCell } from "VSS/Features/Directory/DirectoryGrid";
import { IDirectoryViewState } from "VSS/Features/ReduxDirectory/Contracts";
import { DirectoryActions } from "VSS/Features/ReduxDirectory/redux/DirectoryActions";
import { getFavoriteMap, getFavoritesViewPermission } from "VSS/Features/ReduxDirectory/Redux/DirectorySelectors";
import { FavoriteActions } from "VSS/Features/ReduxDirectory/redux/Favorites/FavoriteActions";
import { css } from "VSS/Platform/Layout";
import { VssComponent } from "VSS/Platform/Layout";

export interface IFavoriteNameCellProps<T extends IDirectoryArtifact> extends IFavoriteNameCellOwnProps<T>, IFavoriteNameCellMappedProps {}

export interface IFavoriteNameCellMappedProps {
    /** The favorites that have been loaded */
    favorites: { [key: string]: IFavoriteData };
    /** Permission describing whether the current user can use favorites. */
    canUseFavorites: boolean;
}

export interface IFavoriteNameCellOwnProps<T extends IDirectoryArtifact> {
    row: IDirectoryRow<T>;
}

/**
 * Legacy code - will be removed once new Dashboard directory is moved to GA
 * The name cell renders the name portion of a row and handles the favoriting behavior.
 */
export class FavoriteNameCell<T extends IDirectoryArtifact> extends VssComponent<IFavoriteNameCellProps<T> & typeof Actions> {
    public render(): JSX.Element {
        const {
            row: { isFavorited }
        } = this.props;
        const favoriteStar = this.props.canUseFavorites ? (
            <div className={css("directory-row-favorite", isFavorited && "favorited")}>
                <FavoritesStarButton className="directory-row-favorite-icon" isFavorited={isFavorited} onToggleFavorite={this._onFavorite} />
            </div>
        ) : null;

        return (
            <NameCell {...this.props} onClick={this._onClickName}>
                {favoriteStar}
            </NameCell>
        );
    }

    private _onFavorite = (event: React.MouseEvent<any>): void => {
        const { row, onFavoriteToggled, favorites } = this.props;

        const artifactId = row.data.id;
        const favoriteId = favorites[artifactId] ? favorites[artifactId].id : undefined;

        event.stopPropagation();
        if (onFavoriteToggled) {
            onFavoriteToggled(artifactId, row.data.name, favoriteId);
        }
    };

    private _onClickName = (row: IDirectoryRow<T>, index: number | undefined, ev: Event): void => {
        if (row.groupKey === DirectoryGroupKeys.FavoriteGroupKey) {
            FavoritesTelemetry.publishNavigateEvent(
                this.context.pageContext,
                "Microsoft.TeamFoundation.Dashboards.Dashboard",
                "Dashboards Directory View"
            );
        }

        this.props.navigateToUrl(row.data.url);
    };
}

function mapStateToProps<T extends IDirectoryArtifact>(state: IDirectoryViewState<T>): IFavoriteNameCellMappedProps {
    return {
        favorites: getFavoriteMap(state),
        canUseFavorites: getFavoritesViewPermission(state)
    };
}

const Actions = {
    onFavoriteToggled: FavoriteActions.toggleFavorite,
    navigateToUrl: DirectoryActions.navigateToUrl
};

export const ConnectedFavoriteNameCell = connect(
    mapStateToProps,
    Actions
)(FavoriteNameCell);
